import { useRegisterSW } from 'virtual:pwa-register/react'
import { useEffect } from 'react'
import { toast } from 'sonner'

/** Une heure : compromis entre fraîcheur et sollicitations réseau. */
const UPDATE_CHECK_INTERVAL = 60 * 60 * 1000

/**
 * Propose une mise à jour au lieu de l'appliquer d'office.
 * Un rechargement automatique interromprait un placeur en pleine séance de
 * scan — d'où `registerType: 'prompt'` dans vite.config.ts.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return
      const timer = window.setInterval(() => {
        void registration.update()
      }, UPDATE_CHECK_INTERVAL)
      return () => window.clearInterval(timer)
    },
  })

  useEffect(() => {
    if (!needRefresh) return

    toast('Nouvelle version disponible', {
      duration: Number.POSITIVE_INFINITY,
      action: {
        label: 'Recharger',
        onClick: () => void updateServiceWorker(true),
      },
      onDismiss: () => setNeedRefresh(false),
    })
  }, [needRefresh, setNeedRefresh, updateServiceWorker])

  return null
}
